module.exports = require("./ta-MY.d.ts");